import { Hourglass } from "lucide-react";
import { useAuth } from "@/context/AuthContext";

export default function PendingPage() {
  const { user, refreshMe, logout } = useAuth();
  return (
    <div className="min-h-screen grid place-items-center p-6" data-testid="pending-page">
      <div className="hb-card max-w-lg w-full p-10 text-center rise">
        <img src="/brand/logo.png" alt="Hey Boo!" className="w-28 mx-auto -rotate-3" />
        <div className="mx-auto mt-4 w-12 h-12 rounded-full bg-[var(--hb-lime-soft)] grid place-items-center">
          <Hourglass size={20} />
        </div>
        <h1 className="font-display text-3xl mt-5">You're on the list, {user.name.split(" ")[0]}!</h1>
        <p className="text-[var(--hb-muted)] mt-3 leading-relaxed">
          Every member is personally approved to keep this a safe, real space for women who are ALL IN.
          You'll get full access as soon as your request is approved.
        </p>
        <div className="flex gap-3 justify-center mt-8">
          <button className="btn-primary" onClick={refreshMe} data-testid="pending-check-again">Check again</button>
          <button className="btn-ghost" onClick={logout} data-testid="pending-logout">Log out</button>
        </div>
      </div>
    </div>
  );
}
